// src/components/Carousel/Carousel.js
import React, { useState, useEffect } from 'react';
import './Carousel.css';

const Carousel = ({ items }) => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const nextSlide = () => {
        setCurrentSlide((prev) =>
            prev === items.length - 1 ? 0 : prev + 1
        );
    };

    const prevSlide = () => {
        setCurrentSlide((prev) =>
            prev === 0 ? items.length - 1 : prev - 1
        );
    };

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    const getVisibleSlides = () => {
        const maxVisible = Math.min(7, items.length); // Show up to 7, but not more than available items
        const positions = [];

        // Calculate how many positions to show on each side
        const leftCount = Math.floor((maxVisible - 1) / 2);
        const rightCount = maxVisible - 1 - leftCount;

        // Generate positions dynamically based on available items
        for (let i = -leftCount; i <= rightCount; i++) {
            positions.push(i);
        }

        return positions.map(position => {
            let index = (currentSlide + position + items.length) % items.length;

            return {
                position,
                item: items[index],
                index
            };
        });
    };

    // Auto-advance slides
    useEffect(() => {
        if (items.length > 1) {
            const interval = setInterval(() => {
                nextSlide();
            }, 5000);
            return () => clearInterval(interval);
        }
    }, [items.length, currentSlide]);

    if (!items || items.length === 0) {
        return (
            <div className="carousel-container">
                <div className="no-items text-center py-5">
                    <p>No items available</p>
                </div>
            </div>
        );
    }

    return (
        <div className="carousel-container">
            <div className="carousel-wrapper">
                {/* Navigation Arrows */}
                {items.length > 1 && (
                    <>
                        <button
                            className="carousel-nav carousel-prev"
                            onClick={prevSlide}
                        >
                            <svg viewBox="0 0 24 24" width="80" height="80" stroke="gray" fill="none" strokeWidth="0.5">
                                <path d="M15 18l-6-6 6-6" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                        <button
                            className="carousel-nav carousel-next"
                            onClick={nextSlide}
                        >
                            <svg viewBox="0 0 24 24" width="80" height="80" stroke="gray" fill="none" strokeWidth="0.5">
                                <path d="M9 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </>
                )}

                {/* Carousel Track */}
                <div className="carousel-track-container">
                    <div className="carousel-track">
                        <div className="carousel-track-container">
                            <div className="carousel-track">
                                {items.map((item, index) => {
                                    // Calculate position relative to current slide (wrap around correctly)
                                    let position = (index - currentSlide + items.length) % items.length;

                                    // Normalize so left slides are negative
                                    if (position > items.length / 2) {
                                        position = position - items.length;
                                    }

                                    return (
                                        <div
                                            key={item.Id || index}
                                            className={`carousel-slide position-${position} ${position === 1 ? 'active' : ''}`}
                                        >
                                            <div className="product-card-carousel">
                                                <div className="image-container">
                                                    <img
                                                        src={item.Image}
                                                        alt={item.Title}
                                                        className="product-image-carousel"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = '/assets/images/placeholder.jpg';
                                                        }}
                                                    />
                                                </div>
                                                <div className="product-info-carousel">
                                                    <h4 className="product-title">{item.Title}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
        </div>
    );
};

export default Carousel;